// Paid-client journey content — one shared design, six routes
// (virtual/in-home × newborn/infant/toddler). Stage and service voice live
// here so PostPayment.jsx stays a single reusable template.

export const STAGE_CONTENT = {
  newborn: {
    label: "Newborn",
    ages: "0–3 months",
    intakeLabel: "Newborn Sleep Intake Form",
    acknowledge:
      "These first weeks run on their own rhythm — frequent waking, days and nights finding their places, contact sleep, settling, feeding and sleep woven together. None of it is a problem to be judged; it's the real picture Andrea needs.",
  },
  infant: {
    label: "Infant",
    ages: "4–17 months",
    intakeLabel: "Infant Sleep Intake Form",
    acknowledge:
      "Naps, night waking, bedtime, a schedule that shifted again, a regression arriving right on schedule — whatever this season looks like in your house, the intake is where Andrea sees all of it clearly.",
  },
  toddler: {
    label: "Toddler",
    ages: "18+ months",
    intakeLabel: "Toddler Sleep Intake Form",
    acknowledge:
      "Bedtime resistance, big transitions, changing naps, nighttime waking, the consistency question — toddlers make sleep a negotiation. The intake lets Andrea understand yours before any of it gets addressed.",
  },
};

export const SERVICE_CONTENT = {
  virtual: {
    label: "Virtual Pediatric Sleep Support",
    line: "Sleep happens at home — and that's exactly where this works. Andrea guides you while the changes are happening in your real rooms and routines, wherever you live.",
  },
  "in-home": {
    label: "In-Home Pediatric Sleep Support",
    line: "Before Andrea steps into your home, she'll already understand your family — your intake is how she prepares, so in-home support starts personal, not introductory.",
  },
};

export const JOURNEY_STEPS = [
  {
    n: "01",
    title: "Complete your intake",
    body: "Share what sleep currently looks like for your child and family.",
  },
  {
    n: "02",
    title: "Andrea reviews everything",
    body: "Andrea personally reviews your child's sleep history, routines, and current challenges.",
  },
  {
    n: "03",
    title: "Schedule your 45-minute Sleep Plan Review",
    body: "Choose a time after Andrea has had enough time to prepare.",
  },
  {
    n: "04",
    title: "Meet with Andrea",
    body: "Walk through the personalized plan, ask questions, and leave knowing exactly what to do next.",
  },
];
